import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 78,
	height: 43,
	viewBox: "0 0 78 43",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2.0005 4.49902C9.99947 36.9996 38.0003 44.5004 70.0599 31.2069",
		stroke: "#D1ECFE",
		strokeWidth: 4,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M71.5 38.5L73.5 28.5L62.5 26",
		stroke: "#D1ECFE",
		strokeWidth: 4,
		strokeLinecap: "round"
	})]
});
export default SvgArrow;
